import loadScript from "load-script";

export const LOAD_WORLD_PAY_REQUEST = "LOAD_WORLD_PAY_REQUEST";
export const LOAD_WORLD_PAY_SUCCESS = "LOAD_WORLD_PAY_SUCCESS";
export const LOAD_WORLD_PAY_ERROR = "LOAD_WORLD_PAY_ERROR";

import config from "../../config";

export const loadCheckOutScript = () => {
  return dispatch => {
    dispatch({ type: LOAD_WORLD_PAY_REQUEST });
    const worldPayAPI = config("WORLD_PAY_API_URL");
    loadScript(`${worldPayAPI}/access-checkout/v1/checkout.js`, function(err) {
      if (err) {
        dispatch({ type: LOAD_WORLD_PAY_ERROR });
        return;
      }
      dispatch({ type: LOAD_WORLD_PAY_SUCCESS });
    });
  };
};
